export const pageTitle = title => {
  return (document.title =
    title + ' -  Cirugía Plástica Facial y Reconstructiva');
};
